import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../App';

const MESICE = ['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec'];

export default function PrehledTym() {
  const { profile: user } = useAuth();
  const now = new Date();
  const [rok, setRok] = useState(now.getFullYear());
  const [mesic, setMesic] = useState(now.getMonth() + 1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);

    // Načti IDs zaměstnanců v týmu vedoucího
    const { data: vazby } = await supabase
      .from('zamestnanec_vedouci')
      .select('zamestnanec_id')
      .eq('vedouci_id', user.id);

    const ids = (vazby || []).map(v => v.zamestnanec_id);
    if (ids.length === 0) { setData([]); setLoading(false); return; }

    // Načti aktivní zaměstnance z týmu
    const { data: zamestnanci } = await supabase
      .from('uzivatele')
      .select('id, jmeno')
      .in('id', ids)
      .eq('aktivni', true)
      .order('jmeno');

    if (!zamestnanci || zamestnanci.length === 0) { setData([]); setLoading(false); return; }

    // Načti schválené výkazy za vybraný měsíc
    const od = `${rok}-${String(mesic).padStart(2,'0')}-01`;
    const do_ = `${rok}-${String(mesic).padStart(2,'0')}-${new Date(rok, mesic, 0).getDate()}`;

    const { data: vykazy } = await supabase
      .from('vykazy')
      .select('zamestnanec_id, hodiny')
      .in('zamestnanec_id', ids)
      .eq('stav', 'schváleno')
      .gte('datum', od)
      .lte('datum', do_);

    // Spočítej hodiny pro každého zaměstnance
    const hodinyMap = {};
    (vykazy || []).forEach(v => {
      hodinyMap[v.zamestnanec_id] = (hodinyMap[v.zamestnanec_id] || 0) + parseFloat(v.hodiny || 0);
    });

    const result = zamestnanci.map(z => ({
      id: z.id,
      jmeno: z.jmeno,
      hodiny: hodinyMap[z.id] || 0,
    }));

    setData(result);
    setLoading(false);
  }, [user.id, rok, mesic]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const celkem = data.reduce((s, z) => s + z.hodiny, 0);

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111', marginBottom: 14 }}>Přehled hodin týmu</h2>

        <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
          <select value={mesic} onChange={e => setMesic(+e.target.value)}
            style={{ border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', background: '#fff', outline: 'none' }}>
            {MESICE.map((m, i) => <option key={i} value={i+1}>{m}</option>)}
          </select>
          <select value={rok} onChange={e => setRok(+e.target.value)}
            style={{ border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', background: '#fff', outline: 'none' }}>
            {[2024,2025,2026].map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          <button onClick={fetchData}
            style={{ background: '#f0f0f0', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', fontWeight: 600 }}>
            🔄 Obnovit
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#888' }}>Načítám…</div>
      ) : data.length === 0 ? (
        <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#888' }}>Žádní zaměstnanci v týmu</div>
      ) : (
        <>
          {/* Souhrnná karta */}
          <div style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 16, borderTop: '3px solid #2d6a4f', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 14, color: '#555', fontWeight: 600 }}>Celkem tým – {MESICE[mesic-1]} {rok}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: '#2d6a4f' }}>{celkem} h</div>
          </div>

          {/* Seznam zaměstnanců */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {data.map(z => (
              <div key={z.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{z.jmeno}</div>
                <div style={{ fontWeight: 800, fontSize: 22, color: z.hodiny > 0 ? '#2d6a4f' : '#aaa' }}>{z.hodiny} h</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
